import { useState, useEffect } from 'react';
import { useUserEntryCount } from 'sdk/hooks/useUserEntryCounts';
import useUser from 'sdk/hooks/user/useUser';

export const useSalesModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { entryCount, incrementEntryCount } = useUserEntryCount();
  const { data: currentUser } = useUser();

  useEffect(() => {
    const checkAndShowModal = async () => {
      if (!currentUser?.user?.id) return;

      if (sessionStorage.getItem('salesModalClosed') === 'true') {
        return;
      }

      const currentCount = await incrementEntryCount() ?? 0;
      if (currentCount > 0 && currentCount % 4 === 0) {
        setIsModalOpen(true);
      }
    };

    checkAndShowModal();
  }, [currentUser]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    closeModal,
  };
};
